<template>
  <div>
    <div v-if="loading">
      <v-overlay>
        <!-- <v-progress-circular indeterminate></v-progress-circular> -->
        <Loader></Loader>
      </v-overlay>
    </div>

    <v-btn
      v-if="showBtn"
      class="appbutton white--text font-weight-medium"
      color="accent"
      :v-bind="size"
      rounded
      @click="rateItemDialog = true"
    >
      <v-img
        width="20px"
        height="20px"
        class="mr-3"
        :src="require('@/assets/fontawesome/clipboard-list-check-duotone.svg')"
      />
      <span class="text-caption">Leave Review</span>
    </v-btn>

    <v-dialog
      v-if="!loading"
      v-model="rateItemDialog"
      dialog-bottom-transition
      persistent
      rounded
      style="border-radius: 12px !important"
      width="80vw"
      max-width="1000px"
    >
      <!-- <div v-if="loading">
        <Loader></Loader>
      </div> -->

      <div>
        <v-card
          style="border-radius: 12px !important; padding-bottom: 8px !important"
        >
          <v-card-title
            style="
              padding: 0px 24px !important;
              font-size: 1em !important;
              line-height: 1.43;
              background-color: #b22af0 !important;
            "
            class="text-center black--text"
          >
            <!-- <v-icon small color="white" @click="rateItemDialog = false"
            >mdi-close</v-icon
          > -->
            <h3
              class="my-3 ml-auto mr-auto"
              style="
                word-break: break-word;
                color: white !important;
                -webkit-hyphens: none !important;
                -moz-hyphens: none !important;
                -ms-hyphens: none !important;
                hyphens: none !important;
              "
            >
              Rate your rental experience using the {{ booking.itemName }}

              <!-- <svg
              height="20px"
              width="20px"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"
            >
              <path
                fill="#B22AF0"
                class="fa-primary"
                d="M175 320.1c9.373 9.371 24.56 9.379 33.94 0l47.03-47.03l47.03 47.03c9.373 9.371 24.56 9.379 33.94 0c9.375-9.375 9.375-24.56 0-33.94L289.9 240l47.03-47.03c9.375-9.375 9.375-24.56 0-33.94s-24.56-9.375-33.94 0l-47.03 47.03L208.1 159c-9.375-9.375-24.56-9.375-33.94 0s-9.375 24.56 0 33.94L222.1 240L175 287C165.7 296.4 165.7 311.6 175 320.1z"
              />
              <path
                fill="#F8955B"
                class="fa-secondary"
                d="M256 31.1c-141.4 0-255.1 93.13-255.1 208c0 49.63 21.35 94.98 56.97 130.7C44.5 421.1 2.729 465.1 2.229 466.5c-2.25 2.25-2.875 5.734-1.5 8.734C1.978 478.2 4.75 479.1 8 479.1c66.25 0 115.1-31.76 140.6-51.39c32.63 12.25 69.02 19.39 107.4 19.39c141.4 0 255.1-93.13 255.1-208S397.4 31.1 256 31.1zM336.1 287c9.375 9.375 9.375 24.56 0 33.94c-9.381 9.379-24.56 9.371-33.94 0l-47.03-47.03l-47.03 47.03c-9.381 9.379-24.56 9.371-33.94 0c-9.375-9.375-9.375-24.56 0-33.94L222.1 240L175 192.1c-9.375-9.375-9.375-24.56 0-33.94s24.56-9.375 33.94 0l47.03 47.03l47.03-47.03c9.375-9.375 24.56-9.375 33.94 0s9.375 24.56 0 33.94L289.9 240L336.1 287z"
              />
            </svg> -->
            </h3>
          </v-card-title>
          <v-divider></v-divider>

          <p
            class="my-3 ml-auto mr-auto text-center"
            style="margin: 16px !important"
          >
            The Strapp team is commited to bringing you a safe,
            community-centric rental marketplace.
          </p>
          <!-- <p class="my-3 ml-auto mr-auto text-center" style="margin: 16px !important;" >
     Please take a moment to rate and review your rental experience with the {{booking.itemName}}.
 </p> -->
          <h4
            class="my-3 ml-auto mr-auto text-center"
            style="margin-bottom: 0px !important"
          >
            Item Rating
          </h4>
          <div class="grid">
            <v-rating
              class="ma-4"
              v-model="rating"
              color="yellow darken-2"
              style="margin-top: 0px !important"
            ></v-rating>
            <h4
              class="my-3 ml-auto mr-auto text-center"
              style="margin-bottom: 4px !important"
            >
              Item Review
            </h4>
            <v-textarea
              v-model="review"
              placeholder="Start typing..."
              color="rgb(34, 34, 34)"
              type="text"
              required
              style="width: 90%"
              solo
              counter
              class="round"
            >
            </v-textarea>
          </div>

          <div style="display: flex; justify-content: center">
            <!-- <v-btn
            elevation="8"
            :width="$vuetify.breakpoint.mdAndUp ? '7rem' : '5rem'"
            class="ebtn ma-3"
            @click="rateItemDialog = false"
            >Close</v-btn
          > -->
            <v-btn
              :loading="loading"
              elevation="8"
              :width="$vuetify.breakpoint.mdAndUp ? '7rem' : '5rem'"
              color="primary"
              class="ebtn ma-3"
              :disabled="review == '' || rating == ''"
              type="submit"
              @click="submitReview()"
              >Submit</v-btn
            >
          </div>
          <p
            class="my-3 ml-auto mr-auto text-center"
            style="margin: 16px !important"
          >
            We really appreciate your feedback and hope to see you again soon.
          </p>
        </v-card>
      </div>
    </v-dialog>

    <v-dialog
      style="border-radius: 12px !important; overflow: hidden"
      v-model="rateSuccessDialog"
      width="550"
    >
      <v-card
        style="border-radius: 12px !important; overflow: hidden"
        class="pa-3 text-center"
      >
        <v-card-title
          style="
            padding: 0px 24px !important;
            font-size: 1em !important;
            line-height: 1.43;
          "
          class="text-center black--text"
        >
          <v-icon small color="black" @click="rateSuccessDialog = false"
            >mdi-close</v-icon
          >
          <p class="my-3 ml-auto mr-auto">Booking succesfully Declined</p>
        </v-card-title>
        <v-divider></v-divider>
        <v-row>
          <v-col cols="12">
            <p>
              <br />
              <br />

              <span class="font-weight-bold text-subtitle-1"
                >We have notified the borrower of your selection</span
              >

              <!-- We really appreciate your feedback we will use it to improve our
              platform to better service you. We hope to get you amazing rental
              experiences in the future. -->
            </p>
          </v-col>
        </v-row>
        <div class="grid">
          <v-btn
            elevation="8"
            width="7rem"
            color="secondary"
            type="submit"
            value="Save Changes"
            class="ebtn"
            @click="reload()"
            >Continue</v-btn
          >
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import firebase from "firebase/compat/app";
import { doc, setDoc, getDoc } from "firebase/firestore";
export default {
  data() {
    return {
      rating: 0,
      review: "",
      max: 500,
      rateItemDialog: false,
      rateSuccessDialog: false,
      loading: false,
    };
  },
  props: ["booking", "showBtn", "open"],
  created() {
    console.log("booking: ", props.booking);
  },
  components: {
    Loader: () => import("@/components/Loader.vue"),
  },

  computed: {
    size() {
      const size = { xs: "small", sm: "medium", lg: "medium", xl: "medium" }[
        this.$vuetify.breakpoint.name
      ];
      return size ? { [size]: true } : {};
    },
    // loading() {
    //   return this.$store.state.loading;
    // },
  },
  methods: {
    async submitReview() {
      // this.$store.commit("setLoading", true);
      this.loading = true;

      // this.rateItem();
      // console.log(this.booking);
      // if (!this.userIsAuthenticated()) {
      //   // TODO
      //   this.loginDialog = true;
      //   this.continueBookingAfterLogin = true;
      // } else {
      // this.showLoadingForBookItem = true;
      // this.bookDialog = false;
      //write a method that submits the dates as well as suburb and comment to firestore collection bookings
      const reviewData = {
        bookingId: this.booking.id,
        itemId: this.booking.itemID,
        itemName: this.booking.itemName,
        lenderID: this.booking.lenderID,
        lenderName: this.booking.lenderName,
        borrowerName: this.booking.borrowerName,
        borrowerID: this.booking.borrowerID,
        rating: this.rating,
        review: this.review,
        reviewType: "item",

        // lenderAvatar: this.item.userAvatar,
        //test
      };
      await this.$store.dispatch("createReview", reviewData).then(async () => {
        if (this.booking.status === "returned") {
          console.log("reviewing item");
          await this.$store.dispatch("updateBookingData", {
            id: reviewData.bookingId,
            status: "returnedB",
          });
          this.$emit("returnedB");
          this.$store.dispatch("loadUserBookings", this.$store.getters.user.id);
        } else if (
          this.booking.status === "returnedL" &&
          this.booking.deposit != null &&
          this.booking.deposit != 0
        ) {
          console.log("reviewing user");
          await this.$store.dispatch("updateBookingData", {
            id: reviewData.bookingId,
            status: "complete",
          });
          this.$emit("complete");
          this.$store.dispatch("loadUserBookings", this.$store.getters.user.id);
        } else if (this.booking.status === "returnedL") {
          console.log("reviewing user");
          this.$emit("complete");
          await this.$store.dispatch("updateBookingData", {
            id: reviewData.bookingId,
            status: "completed",
          });
        }

        // this.showLoadingForBookItem = false;
        // this.successDialog = true;
        // this.bookingAlert = true;
      });

      // }
      // this.rateItemDialog = false;
      // window.location.reload();
      //  this.declinedSuccessDialog = true;
    },

    reload() {
      window.location.reload();
    },

    async rateItem() {
      var db = firebase.firestore();
      let rating_count = 0;
      let rating_avg = 0;
      var data = {};
      console.log(this.booking.id);
      const docRef = await getDoc(doc(db, "items", this.booking.itemID));
      console.log("Document written with ID: ", docRef.data());

      var bookingRef = firebase
        .firestore()
        .collection("items")
        .doc(this.booking.itemID);
      // console.log(docRef);
      if (
        docRef.data().rating_count != null &&
        docRef.data().rating_count != undefined
      ) {
        rating_count = docRef.data().rating_count;
        rating_avg = docRef.data().rating;
      }
      await console.log(
        "rating values: " + docRef.data().rating,
        docRef.data().rating_count,
        this.rating
      );
      bookingRef.update({
        rating: (rating_count * rating_avg + this.rating) / (rating_count + 1),
        rating_count: rating_count + 1,
      });
    },

    // rate() {
    //   console.log(this.booking.id);
    //   var bookingRef = firebase
    //     .firestore()
    //     .collection('items')
    //     .doc(this.booking.itemID);

    //   bookingRef.update({
    //     ratings: {
    //       rating: this.rating,
    //       review: this.review,
    //       timestamp: new Date(),
    //       lenderName: this.booking.borrowerName,
    //       borrowerId: this.booking.borrowerID,
    //     },
    //   });
    //   var bookingRef = firebase
    //     .firestore()
    //     .collection('bookings')
    //     .doc(this.booking.id);
    //   bookingRef.update({
    //     status: 'completed',
    //     updatedAt: new Date(),
    //   });
    //   this.rateItemDialog = false;
    //   this.declinedSuccessDialog = true;
    // },
  },
};
</script>

<style lang="scss" scoped></style>
